import QRCodeStyling from "qr-code-styling"
import { useEffect, useRef } from "react"

// Body-ink hex (feed.css --batyr-ink-rgb): qr-code-styling paints into its
// own SVG, where a CSS var can't resolve, so the value rides along raw. The
// jacket's per-playlist retints are close enough to base ink that the code
// stays scannable either way.
const INK = "#002555"

/**
 * PaperQr — an ink-on-paper QR: square modules, no margin, no frame handles,
 * transparent ground so the card's paper shows through. Deliberately NOT the
 * kit's QRCode (its corner frames + gradient affordance are app styling; this
 * surface reads as print). Decorative — always pair it with the number as
 * visible text.
 */
export function PaperQr({ data, size = 64 }: { data: string; size?: number }) {
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!ref.current) return
    const qr = new QRCodeStyling({
      width: size,
      height: size,
      data,
      type: "svg",
      margin: 0,
      dotsOptions: { color: INK, type: "square" },
      cornersSquareOptions: { color: INK, type: "square" },
      cornersDotOptions: { color: INK, type: "square" },
      backgroundOptions: { color: "transparent" },
    })
    ref.current.replaceChildren()
    qr.append(ref.current)
  }, [data, size])

  return <div ref={ref} aria-hidden="true" className="shrink-0" />
}
